import { FC } from 'react';
import { Card } from 'shared/ui/card/card';
import { InputField } from 'shared/ui/inputField/inputField';
import { ICONS } from 'shared/constants/images';
import { useTranslation } from 'hooks/api/useTranslation';
import { useBillingTransactions } from 'hooks/api/useBillingTransactions';
import { BillingHistoryTable } from './billing-history-table';
import cls from './billing-history.module.scss';
import { Skeleton } from 'shared/ui/skeleton/skeleton';

export const BillingHistory: FC = () => {
  const { t } = useTranslation();
  const {
    transactions,
    totalCount,
    filteredCount,
    failedCount,
    isLoading,
    isFetching,
    page,
    searchInput,
    onSearchInputChange,
    onPageChange,
  } = useBillingTransactions();

  return (
    <Card className={cls.billingHistory}>
      <div className={cls.title}>
        <h2>{t('billingHistory')}</h2>
        <p>
          {isFetching ? <Skeleton width={20} height={20} /> : totalCount}{' '}
          {t('billingTransactions')}
          {failedCount > 0 && (
            <>
              {' '}
              • {failedCount} {t('billingFailed')}
            </>
          )}
        </p>
      </div>
      <div className={cls.header}>
        <InputField
          placeholder={t('billingSearchPlaceholder')}
          icon={ICONS.search}
          loading={isFetching && !isLoading}
          className={cls.searchInput}
          value={searchInput}
          onChange={e => onSearchInputChange(e.target.value)}
        />
      </div>
      <BillingHistoryTable
        transactions={transactions}
        filteredCount={filteredCount}
        page={page}
        hasActiveSearch={searchInput.trim().length > 0}
        isLoading={isLoading || isFetching}
        onPageChange={onPageChange}
      />
    </Card>
  );
};
